import { FloatingButtonState } from '..';
import { DisplayStrategyCallback } from '.';

export function create(
  state: FloatingButtonState,
  setState: (s: Pick<FloatingButtonState, keyof FloatingButtonState>) => void
): DisplayStrategyCallback {
  return () => {
    return new Promise((resolve) => {
      const ssBtn = document.getElementById('saved-search-button');
      const rect = ssBtn?.getBoundingClientRect();
      if (!state.savedSearchButtonOutsideViewport && rect && ssBtn) {
        //saved search button is not in viewport
        const savedSearchButtonOutsideViewport = !(
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom - ssBtn.offsetHeight <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
        // TODO: nasty hack, see https://github.com/microsoft/TypeScript/issues/12793
        setState({
          savedSearchButtonOutsideViewport,
        } as FloatingButtonState);
        resolve(savedSearchButtonOutsideViewport);
        return;
      }
      resolve(true);
    });
  };
}
